import {Injectable} from '@angular/core';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    private readonly DELIMITER: string = '/';

    public parse(value: string): NgbDateStruct | null {
        if (value) {
            const date: string[] = value.split(this.DELIMITER);
            return {
                month: parseInt(date[0], 10),
                day: parseInt(date[1], 10),
                year: parseInt(date[2], 10),
            };
        }
        return null;
    }

    public format(date: NgbDateStruct | null): string {
        return date
            ? date.month + this.DELIMITER + date.day + this.DELIMITER + date.year
            : '';
    }
}
